export enum GoogleAnalyticsAction {
  Login = 'Login',
  FlightSearch = 'FlightSearch',
  FlightCheckout = 'FlightCheckout',
  FlightRegistry = 'FlightRegistry',
  FlightPayment = 'FlightPayment',
}
